/**
 * Created by Arif Topcu in 2019
 */

import {applyMiddleware, compose, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from 'state/reducer';

const getStore = () => {
  let store;
  if (process.env.NODE_ENV === 'development') {
    const logger = require('redux-logger').default;
    if(window.__REDUX_DEVTOOLS_EXTENSION__) {
      store = createStore(
        reducer, compose(
          applyMiddleware(
            thunkMiddleware,
            logger,
          ),
          window.__REDUX_DEVTOOLS_EXTENSION__(),
        ),
      );
    } else {
      store = createStore(
        reducer, compose(
          applyMiddleware(
            thunkMiddleware,
            logger,
          ),
        ),
      );
    }
  } else {
    store = createStore(
      reducer, compose(
        applyMiddleware(
          thunkMiddleware,
        ),
      ),
    );
  }
  return store;
};

export default getStore();
